import {RoomMetadata, SjMatrixMessageType} from '@/types/matrix';
import {Direction, Room} from 'matrix-js-sdk';

export const getMetadata = (room: Room): RoomMetadata | null => {
  const stateEvents =
    room
      .getLiveTimeline()
      .getState(Direction.Forward)
      ?.getStateEvents(SjMatrixMessageType.Metadata) || [];
  if (stateEvents.length > 0) {
    const e = stateEvents[stateEvents.length - 1];
    const content = e.getContent() as RoomMetadata;
    return content;
  }
  return null;
};

export default getMetadata;
